/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The props for `<SearchFilter />`.
 */
export interface SearchFilterProps {
  /**
   * Custom icon.
   */
  customIcon?: JSX.Element;

  /**
   * The filter value.
   */
  filterValue: string;

  /**
   * The label of the search filter.
   */
  label: string;

  /**
   * Placeholder text.
   */
  placeholder: string;

  /**
   * The function to set filter value.
   */
  setFilterValue: React.Dispatch<React.SetStateAction<string>>;
}

/**
 * The default prop values for `<SearchFilter />`.
 */
export const searchFilterDefaults = {
  label: `Search filter`,
  placeholder: `Filter by keyword`,
};
